import axios from 'axios';
import cookie from '../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function getReelInsightsV2(data, type) {
    let API_URL;
    let startDate = data.startDate || "";
    let endDate = data.endDate || "";

    // Construct API URL
    API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/reelInsightsv2?type=${type}&startDate=${startDate}&endDate=${endDate}`;

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return (
        axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log('res.data: ', res.data);
            return res.data;
        })
        .catch(err => {
            // console.error('Error fetching reel insights: ', err);
            return err;
        })
    );
}
